import { render } from "./FileDrop.vue?vue&type=template&id=1b15d73e&scoped=true&lang=pug"
import script from "./FileDrop.vue?vue&type=script&lang=js"
export * from "./FileDrop.vue?vue&type=script&lang=js"

import "./FileDrop.vue?vue&type=style&index=0&id=1b15d73e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b15d73e"]])

export default __exports__